export const DIAGRAM = 'DDiagram';
export const SHAPE = 'DShape';
export const LAYOUT = 'DLayout';
